var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExploreAndSelectSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 726,
    height: 465,
    viewBox: "0 0 726 465",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M723.924 0H2C0.89543 0 0 0.895419 0 1.99999V462.914C0 464.019 0.895428 464.914 2 464.914H723.924C725.029 464.914 725.924 464.019 725.924 462.914V2C725.924 0.895431 725.029 0 723.924 0Z",
    fill: "#F7DFCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M723.954 0H2.03027C0.925704 0 0.0302734 0.895431 0.0302734 2V28.8399C0.0302734 29.9445 0.925702 30.8399 2.03027 30.8399H723.954C725.059 30.8399 725.954 29.9445 725.954 28.8399V2C725.954 0.89543 725.059 0 723.954 0Z",
    fill: "#D75F04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9474 21.4836C26.1042 21.4836 28.6633 18.9245 28.6633 15.7677C28.6633 12.6109 26.1042 10.0518 22.9474 10.0518C19.7906 10.0518 17.2314 12.6109 17.2314 15.7677C17.2314 18.9245 19.7906 21.4836 22.9474 21.4836Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6437 21.4836C47.8005 21.4836 50.3596 18.9245 50.3596 15.7677C50.3596 12.6109 47.8005 10.0518 44.6437 10.0518C41.4868 10.0518 38.9277 12.6109 38.9277 15.7677C38.9277 18.9245 41.4868 21.4836 44.6437 21.4836Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.34 21.4836C69.4968 21.4836 72.0559 18.9245 72.0559 15.7677C72.0559 12.6109 69.4968 10.0518 66.34 10.0518C63.1831 10.0518 60.624 12.6109 60.624 15.7677C60.624 18.9245 63.1831 21.4836 66.34 21.4836Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M703.069 58.3066H22.6602C21.5556 58.3066 20.6602 59.2021 20.6602 60.3066V435.405C20.6602 436.509 21.5556 437.405 22.6602 437.405H703.069C704.174 437.405 705.069 436.509 705.069 435.405V60.3066C705.069 59.2021 704.174 58.3066 703.069 58.3066Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M257.146 100.053H85.2852C84.1806 100.053 83.2852 100.949 83.2852 102.053V398.482C83.2852 399.587 84.1806 400.482 85.2852 400.482H257.146C258.251 400.482 259.146 399.587 259.146 398.482V102.053C259.146 100.949 258.251 100.053 257.146 100.053Z",
    fill: "#F7DFCD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M434.054 205.779H291.503C290.398 205.779 289.503 206.675 289.503 207.779V292.757C289.503 293.861 290.398 294.757 291.503 294.757H434.054C435.158 294.757 436.054 293.861 436.054 292.757V207.779C436.054 206.675 435.158 205.779 434.054 205.779Z",
    fill: "#D75F04",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M434.054 317.786H291.503C290.398 317.786 289.503 318.682 289.503 319.786V398.483C289.503 399.587 290.398 400.483 291.503 400.483H434.054C435.158 400.483 436.054 399.587 436.054 398.483V319.786C436.054 318.682 435.158 317.786 434.054 317.786Z",
    fill: "#D75F04",
    fillOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M641.318 100.053H469.457C468.352 100.053 467.457 100.949 467.457 102.053V228.979C467.457 230.083 468.352 230.979 469.457 230.979H641.318C642.422 230.979 643.318 230.083 643.318 228.979V102.053C643.318 100.949 642.422 100.053 641.318 100.053Z",
    fill: "#D75F04",
    fillOpacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M641.318 269.558H469.457C468.352 269.558 467.457 270.453 467.457 271.558V398.483C467.457 399.587 468.352 400.483 469.457 400.483H641.318C642.422 400.483 643.318 399.587 643.318 398.483V271.558C643.318 270.453 642.422 269.558 641.318 269.558Z",
    fill: "#D75F04",
    fillOpacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M434.054 100.053H291.503C290.398 100.053 289.503 100.949 289.503 102.053V180.75C289.503 181.854 290.398 182.75 291.503 182.75H434.054C435.158 182.75 436.054 181.854 436.054 180.75V102.053C436.054 100.949 435.158 100.053 434.054 100.053Z",
    fill: "#D75F04"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 421.085,
    cy: 155.085,
    r: 79.0845,
    stroke: "#010506",
    strokeWidth: 20
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M472.038 216.123L538.384 284.592",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreAndSelectSlider);
export default __webpack_public_path__ + "static/media/explore-and-select-slider.db9c04f2b321d2c4950936c2e4464259.svg";
export { ForwardRef as ReactComponent };